<!-- <div>
  <h3>
    <b> Usuarios Conectados ({{ users?.length }})</b>
  </h3>
  <app-user-conected-card
    *ngFor="let user of users"
    [user]="user.idUser"
  ></app-user-conected-card>
</div> -->
<div class="content">
  <div>
    <h3 class="title">Usuarios conectados al sistema</h3>
  </div>
  <div class="search-content">
    <div class="searchbar">
      <input
        #input
        class="search_input"
        (keyup)="filter($event)"
        type="text"
        placeholder="Filtrar..."
      />
      <button class="search_icon" (click)="filter($event)">
        <i class="fas fa-search"></i>
      </button>
    </div>
  </div>
  <div class="main">
    <div class="table-content mat-elevation-z8">
      <div class="table-scroll">
        <!-- Mat table -->
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="spacing">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <img class="userPhoto" [src]="getPhoto(element)" alt="" />
            </td>
          </ng-container>

          <ng-container matColumnDef="fullname">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.fullname }}</td>
          </ng-container>
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let element">
              {{ element.username }}
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Rol</th>
            <td mat-cell *matCellDef="let element">
              {{ element.role ? element.role.name : "Sin rol" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef>Sesiones</th>
            <td mat-cell *matCellDef="let element">
              {{ element.count ? element.count : "1" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        [pageSizeOptions]="[10, 25, 100]"
        aria-label="Select page of users"
      ></mat-paginator>
    </div>
  </div>
</div>
